import { useState, useEffect } from 'react'
import { TextField, Grid, Box, Typography } from '@mui/material'

function ContactDetails ({ onValidationChange, showErrors, formData, onFormDataChange }) {
  const [errors, setErrors] = useState({})

  const handleChange = (e) => {
    const { name, value } = e.target
    onFormDataChange({ [name]: value })
  }

  useEffect(() => {
    const newErrors = {}
    if (!formData.mobileNumber || isNaN(formData.mobileNumber.replace(/[-+\s+()]/g, ''))) newErrors.mobileNumber = 'Valid mobile number is required'
    if (!formData.email) newErrors.email = 'Email is required'

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
    if (formData.email && !emailRegex.test(formData.email)) newErrors.email = 'Enter a valid email address'
    setErrors(newErrors)
    onValidationChange(Object.keys(newErrors).length === 0)
  }, [formData, onValidationChange])

  return (
    <Box sx={{ mb: 3 }}>
      <Typography variant='h6'>Contact Details</Typography>
      <Grid container spacing={2} mt={2}>
        <Grid size={{ xs: 12, sm: 6 }}>
          <TextField
            label='Mobile Number'
            name='mobileNumber'
            variant='outlined'
            fullWidth
            value={formData.mobileNumber || ''}
            onChange={handleChange}
            error={!!errors.mobileNumber && showErrors}
            helperText={showErrors ? errors.mobileNumber : ''}
            required
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 6 }}>
          <TextField
            label='Alternative Number'
            name='alternativeNumber'
            variant='outlined'
            fullWidth
            value={formData.alternativeNumber || ''}
            onChange={handleChange}
          />
        </Grid>
        <Grid size={{ xs: 12 }}>
          <TextField
            label='Email'
            name='email'
            variant='outlined'
            fullWidth
            value={formData.email || ''}
            onChange={handleChange}
            error={!!errors.email && showErrors}
            helperText={showErrors ? errors.email : ''}
            required
          />
        </Grid>
      </Grid>
    </Box>
  )
}

export default ContactDetails
